// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__KAhU8","large":"styles_large__1OBqp"};